<template>
  <el-row class="profile-container" >
    <el-col :span="6" :offset="1" class="profile-sidebar">
      <el-menu :default-active="$router.currentRoute.path" router>
        <el-menu-item :index="Paths.USER_PROFILE_INFORMATION">
          Thông tin cá nhân
        </el-menu-item>
        <el-menu-item :index="Paths.USER_PROFILE_SECURITY">
          Mật khẩu
        </el-menu-item>
      </el-menu>
    </el-col>
    <el-col :span="15" :offset="1">
      <router-view></router-view>
    </el-col>
  </el-row>
</template>

<script>

import { Paths } from "@/routes/paths.js"
import FAIcon from "@/components/common/FAIcon.vue"

export default {
  name: "UserProfileView",
  components: { FAIcon },
  data: function () {
    return {
      Paths,
    }
  },
}
</script>

<style lang="scss" scoped>
.profile-sidebar {
  border: 1px solid #eee;
}
.list-group-transparent {
  .list-group-item {
    background: none;
    border: 0;
    font-weight: 400;
    padding: 0.5rem 1rem;
    border-radius: 3px;
    font-size: 15px;
    color: #3b3c3f;
  }
  .list-group-item.active {
    background: rgba(70, 127, 207, 0.06);
    font-weight: 600;
    color: #467fcf;
  }
  .list-group-item:hover {
    background: rgba(70, 127, 207, 0.06);
    font-weight: 600;
    color: #467fcf;
  }
}
</style>

<style lang="scss">
  .profile-sidebar {
    .el-menu-item.is-active {
      background-color: whitesmoke;
    }
  }

</style>
